import { render, staticRenderFns } from "./manage_price.vue?vue&type=template&id=15921c0c&scoped=true&"
import script from "./manage_price.vue?vue&type=script&lang=js&"
export * from "./manage_price.vue?vue&type=script&lang=js&"
import style0 from "./manage_price.vue?vue&type=style&index=0&id=15921c0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15921c0c",
  null
  
)

export default component.exports